
$(document).ready(function() {
	var modalReviewCreate = null;
	var modalReviews = null;

	if ($('#modalReviewCreate').length > 0) {
		modalReviewCreate = new bootstrap.Modal('#modalReviewCreate', {
			keyboard: false
		});
	}
	if ($('#modalReviews').length > 0) {
		modalReviews = new bootstrap.Modal('#modalReviews', {
			keyboard: false
		});
	}

	$(document).on('click', ".product-view-reviews",function(event) {
		event.preventDefault();

		modalReviews.show();
	});

	$(document).on('click', ".product-review-create",function(event) {
		event.preventDefault();

		modalReviews.hide();
		modalReviewCreate.show();
	});

	$(document).on('click', ".product-rating-start",function(event) {
		event.preventDefault();

		let rating = $(this).data('rating');

		$('#product-rating-form').attr('data-rating', rating);
	});

	$('.product-rating-start').on( "mouseenter", function() {
		let rating = $(this).data('rating');

		for(let i = 1; i <= 5; i++) {
			if (i <= rating) {
				$('#rating-start-' + i).find('i').removeClass('far').addClass('fas');
			} else {
				$('#rating-start-' + i).find('i').removeClass('fas').addClass('far');
			}
		}
	}).on( "mouseleave", function() {
		
	});

	$('.rating-stars-wrapper').on( "mouseenter", function() {
		
	}).on( "mouseleave", function() {
		let rating = 1*$('#product-rating-form').attr('data-rating');

		for(let i = 1; i <= 5; i++) {
			if (i <= rating) {
				$('#rating-start-' + i).find('i').removeClass('far').addClass('fas');
			} else {
				$('#rating-start-' + i).find('i').removeClass('fas').addClass('far');
			}
		}
	});

	let ratingIsLoading = false;
	$(document).on('click', '#save-rating-btn', function(e) {
		e.preventDefault();
		let productId = $(this).data('id');
		if (!productId) { return false; }

		let rating = 1*$('#product-rating-form').attr('data-rating');
		if (!rating || rating < 1) {
			Swal.fire({
				// icon: 'error',
				// title: 'Oops...',
				text: $('#product-rating-form').data('rating-error-text')
			});
			return false;
		}

		$('#product-rating-form').find('.form-control').removeClass('is-invalid');
		$('#product-rating-form').find('.form-check-input').removeClass('is-invalid');

		var errors = false;
		if ($('#rating_name').val() == '') {
			$('#rating_name').addClass('is-invalid');
			errors = true;
		}
		if ($('#rating_email').val() == '') {
			$('#rating_email').addClass('is-invalid');
			errors = true;
		}
		if (!$('#rating_terms_and_conditions').is(':checked')) {
			$('#rating_terms_and_conditions').addClass('is-invalid');
			errors = true;
		}

		if (errors) {
			return false;
		}

		if (ratingIsLoading) { return false; }
        ratingIsLoading = true;
		$('#save-rating-btn').find('i').show();

		var values='';
        values+='id=' + productId;
        values+='&rating=' + rating;
        values+='&name=' + $('#rating_name').val();
        values+='&email=' + $('#rating_email').val();
        values+='&text=' + $('#rating_text').val();

        $.ajax({
            type: "POST",
            url: baseURL + "/product/rating",
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            dataType: "JSON",
            data: values,
            success: function(response) {
                ratingIsLoading = false;
				$('#save-rating-btn').find('i').hide();

				if (response.status == 0) {
					var errorHtml = '';
					for(var errorKey in response.errors) {
						if(!response.errors.hasOwnProperty(errorKey)) continue;
						for(var error in response.errors[errorKey]) {
							errorHtml += response.errors[errorKey][error] + '<br>';
							$('#rating_' + errorKey).addClass('is-invalid');
						}
					}
					return false;
				}

				if (response.status == 1) {
					Swal.fire({
						// icon: 'error',
						// title: 'Oops...',
						text: response.message
					});

					$('#product-rating-form').attr('data-rating', '0');
					$('.rating-stars-wrapper').find('i').removeClass('fas').addClass('far');
					$('#rating-notifications').html('');
					$('#rating_name').val('');
					$('#rating_email').val('');
					$('#rating_text').val('');
					$('#rating_terms_and_conditions').prop('checked', false);

					modalReviewCreate.hide();

					return false;
				}

				$('#rating-notifications').html('<div class="alert alert-danger">'+response.message+'</div>');
				return false;
			},
			error(error) {
                ratingIsLoading = false;
				$('#save-rating-btn').find('i').hide();
				$('#rating-notifications').html('<div class="alert alert-danger">Error: Something went wrong please contact and administrator!</div>');
            }
		});
	});

	$(".go-to-reviews").click(function (){
        $('html, body').animate({
            scrollTop: $("#product-rating-summary").offset().top
        }, 1500);
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/ratings.js